import flow from 'lodash/flow';
import fpNth from 'lodash/fp/nth';
import fpSplit from 'lodash/fp/split';

/** Marge (secondes) avant `exp` : en dessous, le jeton est renouvelé côté API. */
export const ACCESS_TOKEN_RENEW_MARGIN_SEC = 90;

export function readAccessTokenData({ accessToken }) {
  try {
    if (!accessToken) {
      return undefined;
    }
    const tokenData = flow(fpSplit('.'), fpNth(1))(accessToken);
    return JSON.parse(atob(tokenData));
  } catch (err) {
    return undefined;
  }
}

/**
 * Indique si le JWT correspond encore à l’espace demandé et n’est pas trop proche de l’expiration.
 * Utilisé pour réutiliser `token` ou `workspace_tokens` sans refaire `POST .../token`.
 */
export function isAccessTokenValidForApp(accessToken, appId, marginSec = ACCESS_TOKEN_RENEW_MARGIN_SEC) {
  const data = readAccessTokenData({ accessToken });
  if (!data?.appId || !appId || data.appId !== appId) {
    return false;
  }
  if (typeof data.exp !== 'number') {
    return false;
  }
  const nowSec = Date.now() / 1000;
  return data.exp > nowSec + marginSec;
}

/** Jeton espace client stocké par l’auth (`workspace_tokens` dans localStorage). */
export function getStoredWorkspaceToken(appId) {
  if (!appId) {
    return null;
  }
  try {
    const raw = localStorage.getItem('workspace_tokens');
    if (!raw) {
      return null;
    }
    const map = JSON.parse(raw);
    const token = map?.[appId];
    return typeof token === 'string' && token.length > 0 ? token : null;
  } catch {
    return null;
  }
}
